import { QuoteSearchRequestQuery } from '@lio/api-types';
import { buildQueryParamForArray } from '@utils/buildQueryParamForArray';

export type QuoteSearchRequestQueryWithOptionalType = Omit<QuoteSearchRequestQuery, 'quoteType' | 'underwriterId'> & {
  quoteType?: string[] | null;
  underwriterId?: string[] | null;
  underwritingActivityTypeId?: string[] | null;
};

export const buildQuoteSearchUrl = (params: QuoteSearchRequestQueryWithOptionalType) => {
  const {
    pageOffset,
    pageLimit,
    quoteType,
    statuses,
    watchedByUserId,
    pinnedByUserId,
    sort,
    searchText,
    offeringId,
    productOptionId,
    productLabelId,
    writingCompanyId,
    effectiveOnMax,
    effectiveOnMin,
    updatedAtMax,
    updatedAtMin,
    jurisdictionId,
    totalPremiumMax,
    totalPremiumMin,
    underwriterId,
    brokerageId,
    brokerageProducerId,
    createdByUserId,
    createdByUserFullName,
    hasDuplicateQuotes,
    searchType,
    searchUserId,
    quoteOriginId,
    reportingQuoteSource,
    underwritingActivityTypeId,
  } = params;

  const query = new URLSearchParams();

  if (sort) {
    query.append('sort', sort);
  }

  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }

  if (pageLimit) {
    query.append('pageLimit', pageLimit.toString());
  }

  if (statuses) {
    buildQueryParamForArray(query, 'statuses', statuses);
  }

  if (quoteType) {
    buildQueryParamForArray(query, 'quoteType', quoteType);
  } else if (quoteType === undefined) {
    // allow 'null' to be passed to not default this
    buildQueryParamForArray(query, 'quoteType', 'NewBusiness');
  }

  if (watchedByUserId) {
    query.append('watchedByUserId', watchedByUserId);
  }
  if (pinnedByUserId) {
    query.append('pinnedByUserId', pinnedByUserId);
  }

  if (searchText) {
    query.append('searchText', searchText);
  }
  if (offeringId) {
    buildQueryParamForArray(query, 'offeringId', offeringId);
  }
  if (productOptionId) {
    buildQueryParamForArray(query, 'productOptionId', productOptionId);
  }
  if (productLabelId) {
    buildQueryParamForArray(query, 'productLabelId', productLabelId);
  }
  if (writingCompanyId) {
    query.append('writingCompanyId', writingCompanyId);
  }
  if (effectiveOnMax) {
    const effectiveOnMaxDate = new Date(effectiveOnMax);
    query.append('effectiveOnMax', effectiveOnMaxDate.toISOString());
  }
  if (effectiveOnMin) {
    const effectiveOnMinDate = new Date(effectiveOnMin);
    query.append('effectiveOnMin', effectiveOnMinDate.toISOString());
  }
  if (updatedAtMax) {
    const updatedAtMaxDate = new Date(updatedAtMax);
    query.append('updatedAtMax', updatedAtMaxDate.toISOString());
  }
  if (updatedAtMin) {
    const updatedAtMinDate = new Date(updatedAtMin);
    query.append('updatedAtMin', updatedAtMinDate.toISOString());
  }
  if (jurisdictionId) {
    buildQueryParamForArray(query, 'jurisdictionId', jurisdictionId);
  }
  if (totalPremiumMax) {
    query.append('totalPremiumMax', totalPremiumMax.toString());
  }
  if (totalPremiumMin) {
    query.append('totalPremiumMin', totalPremiumMin.toString());
  }

  if (underwriterId) {
    buildQueryParamForArray(query, 'underwriterId', underwriterId);
  }

  if (brokerageId) {
    buildQueryParamForArray(query, 'brokerageId', brokerageId);
  }
  if (brokerageProducerId) {
    buildQueryParamForArray(query, 'brokerageProducerId', brokerageProducerId);
  }

  if (createdByUserId) {
    query.append('createdByUserId', createdByUserId);
  }

  if (createdByUserFullName) {
    query.append('createdByUserFullName', createdByUserFullName);
  }

  if (hasDuplicateQuotes) {
    query.append('hasDuplicateQuotes', hasDuplicateQuotes.toString());
  }

  if (searchType) {
    query.append('searchType', searchType);
  }

  if (searchUserId) {
    query.append('searchUserId', searchUserId);
  }

  if (quoteOriginId) {
    query.append('quoteOriginId', quoteOriginId);
  }

  if (reportingQuoteSource) {
    buildQueryParamForArray(query, 'reportingQuoteSource', reportingQuoteSource);
  }

  if (underwritingActivityTypeId) {
    buildQueryParamForArray(query, 'underwritingActivityTypeId', underwritingActivityTypeId);
  }

  return {
    queryParams: query,
  };
};
